/*
 * Copyright (c) 2014-2023 Comparatio
 */

import {Routes } from '@angular/router';

import {UserComponent } from './user.component';
import {permissions } from '../../permissions';
import {NgxPermissionsGuard } from 'ngx-permissions';
import {UserAddComponent } from './user-add/user-add.component';
import {AuthGuardService as AuthGuard} from './../../auth-guard.service';
import {UserChangepasswordComponent} from './user-changepassword/user-changepassword.component';
import {AdminChangepasswordComponent} from './admin-changepassword/admin-changepassword.component';
import {PermissionsComponent} from './permissions/permissions.component';
import {RolesComponent} from './roles/roles.component';

import { ProfileComponent } from './profile/profile.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import {UserAccessComponent} from './user-access/user-access.component';
import {UserRegisterComponent} from './user-register/user-register.component';
import {UserFormComponent} from './user-form/user-form.component';

export const routes: Routes = [
    {
        path: 'user',
        component: UserComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.USERS_READ, permissions.SUBORDINATE_USER_READ]
            }
        }
    }, {
        path: 'user/add/:id',
        component: UserAddComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.USERS_ADD]
            }
        }
    }, {
        path: 'user/change-password/:id',
        component: UserChangepasswordComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.CHANGE_PASSWORD]
            }
        }
    }, {
        path: 'user/admin-change-password/:id',
        component: AdminChangepasswordComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.ADMIN_CHANGE_PASSWORD]
            }
        }
    }, {
        path: 'user/permissions/:id',
        component: PermissionsComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.USERS_EDIT]
            }
        }
    }, {
        path: 'user/roles/:id',
        component: RolesComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.USERS_EDIT]
            }
        }
    }, {
        path: 'user/profile',
        component: ProfileComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.PROFILE_READ]
            }
        }
    }, {
        path: 'user/profile/:id',
        component: ProfileComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.PROFILE_READ]
            }
        }
    }, {
        path: 'user/profile/edit/:id',
        component: UserEditComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.USERS_EDIT]
            }
        }
    }, {
        path: 'user/register/:id',
        component: UserRegisterComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.USERS_REGISTER]
            }
        }
    }, {
        path: 'user/access/:id',
        component: UserAccessComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.MANAGE_ACCESS_RIGHTS]
            }
        }
    }, {
        path: 'user/create',
        component: UserFormComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.SUBORDINATE_USER_ADD]
            }
        }
    }, {
        path: 'user/edit/:id',
        component: UserFormComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.SUBORDINATE_USER_EDIT]
            }
        }
    }
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user.routing.ts